<template>
	<ul class="informationList">
		<li v-for="news in NewsList" :key="news.id" @click="newDetail(news.id)">{{news.title}}</li>
	</ul>

</template>

<script>
	import {
		queryNewsList
	} from "@/api/msg/msg";
	export default {
		name: "informationList",
		props: {
			title: {
				type: String,
				default: () => (
					''
				)
			},
		},
		data() {
			return {
				page: {
					page: 0,
					limit: document.body.clientWidth >= 1920 ? 7 : 4
				},
				NewsList: []
				// dialogheaderVisible:false,
			}
		},
		created() {
			queryNewsList('new', this.page).then(res => {
				this.NewsList = res.data.data.records;
			})
		},
		methods: {
			newDetail(id) {
				this.$router.push({path:'/info',query:{id:id}})
			}
		}
	};
</script>

<style scoped>
	.informationList {
		height: 166px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 4px 0px rgba(187, 187, 187, 0.25);
		border-radius: 4px;
		padding: 16px 30px 16px 20px;
		box-sizing: border-box;
	}

	@media screen and (min-width: 1920px) {
		.informationList {
			height: 266px;
		}
	}

	ul li {
		font-size: 14px;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 20px;
		width: 100%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		padding: 7px 0;
		border-bottom: 1px dashed #B0B0B0;
		cursor: pointer;
	}

	ul li:nth-of-type(1) {
		padding-top: 0px;
	}
</style>
